import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

// Register locales for Angular DatePipe (e.g. month names/abbreviations)
registerLocaleData(localeEn);
registerLocaleData(localeDe);

const filterSentryExceptions = (
  event: Sentry.ErrorEvent,
  hint: Sentry.EventHint
): Sentry.ErrorEvent | null => {
  if (hint.originalException && hint.originalException instanceof Error) {
    const message = hint.originalException.message?.toLowerCase() || '';
    if (message.includes('token expired') ||
      message.includes('invalid token') ||
      message.includes('unauthorized')) {
      return null;
    }
  }
  return event;
};

if (environment.sentry?.enabled && environment.sentry?.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    enableLogs: true,
    enableMetrics: true,
    tracesSampleRate: environment.sentry.tracesSampleRate,
    replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate ?? 0,
    replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate ?? 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    beforeSend: filterSentryExceptions,
    allowUrls: [
      'https://scribe.tpro.rocks',
      'https://scribe.tpro.io',
      /https?:\/\/(localhost|127\.0\.0\.1)/,
    ],
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    console.error('Bootstrap error:', err);
    if (environment.sentry?.enabled) {
      Sentry.captureException(err);
    }
  });
